import { React } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { ToggleButton } from "@material-ui/lab";
const useStyles = makeStyles((theme) => ({
  customToggleButton: {
    borderColor: "transparent",
    backgroundColor: theme.midGray,
    bordeRadius: 8,
    width: 80,
    margin: "0 10px 0px 0px",
    "&$selected": { backgroundColor: theme.blue, color: theme.black },
  },
  selected: {},

  box: {
    display: "block",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  nameOfButton: {
    textAlign: "center",
    color: "white",
  },
}));
function CustomToggleButtons({ nameOfButton, key, value, onClick, selected }) {
  const classes = useStyles();
  return (
    <ToggleButton
      value={value}
      key={key}
      onClick={onClick}
      selected={selected}
      classes={{
        root: classes.customToggleButton,
        selected: classes.selected,
      }}
    >
      <Box className={classes.box}>
        <Typography
          classes={{
            root: classes.nameOfButton,
          }}
        >
          {nameOfButton}
        </Typography>
      </Box>
    </ToggleButton>
  );
}

export default CustomToggleButtons;
